import { Avatar, Button, Clickable, Col, Icon, Row, Text } from 'components';
import { normalizeDate, theme } from 'lib';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ShareModal } from './';

const Header = ({ post, owner, handleClose, isFollowing, handleFollowClick, fromNavigation, isSharedPost }) => {
  const [showShare, setShowShare] = useState(false),
    { t } = useTranslation(),
    navigate = useNavigate();

  if (!owner) return null;
  if (!post) return null;

  return (
    <React.Fragment>
      <Row
        wid="calc(100% - 48px)"
        pad="24px 24px"
        between
        borderBottom={`1px solid ${theme.GREY_20}`}
        center
      >
        <Clickable
          onClick={() => {
            navigate(`/profile/${owner.username}`);
            handleClose();
          }}
        >
          <Row center>
            <Avatar user={owner} small />

            <Col marg="0 0 0 8px" center gap="2px">
              <Text b2 bold>
                {owner.name}
              </Text>

              <Text c1 med col={theme.GREY_60}>
                {normalizeDate(post.createdAt, 'Default', t)}
              </Text>
            </Col>
          </Row>
        </Clickable>

        <Row center gap="16px">
          {fromNavigation && !isSharedPost && !isFollowing && (
            <Button
              text={t('common.follow')}
              bg={theme.SECONDARY}
              pad="4px 12px"
              onClick={handleFollowClick}
            />
          )}
          <Clickable onClick={() => setShowShare(true)}>
            <Icon type="share" dimensions={18} col={theme.GREY_60} />
          </Clickable>
        </Row>
      </Row>

      <Row pos="relative" wid="100%">
        {showShare && (
          <ShareModal post={post} showShare={showShare} handleClose={() => setShowShare(false)} />
        )}
      </Row>
    </React.Fragment>
  );
};

export default Header;
